export const isEmpty = (value?: unknown): boolean => {
  if (!value) {
    return true;
  }
  if (Array.isArray(value)) {
    return value.length === 0;
  }
  if (value == null) {
    return true;
  }
  if (typeof value === 'string') {
    return value.length > 0;
  }

  return Object.keys(value).length === 0;
};

export const convertEmptyStringToUndefinedFromObject = <T extends object>(
  data: T,
): { [K in keyof T]: T[K] | undefined } => {
  const result = {} as { [K in keyof T]: T[K] | undefined };

  for (const key in data) {
    const value = data[key as keyof T];
    result[key as keyof T] = value === '' ? undefined : value;
  }

  return result;
};
